import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/apps/_list/alerts/_alerts/")({
  beforeLoad: () => {
    throw redirect({ to: "/apps/alerts/shadow-it" });
  },
});
